import { z } from "zod/v4-mini";

import { TandemCommand, TandemResponse } from "@/lib/drivers/tandem/TandemTypes";
import { Schema } from "@/utils/zodUtils";

export type PersonalProfileListPayload = {
  num_available: number;
  slot1: number;
  slot2: number;
  slot3: number;
  slot4: number;
  slot5: number;
  slot6: number;
};

export type PersonalProfileList = {
  numAvailable: number;
  slots: number[];
};

export const personalProfileListPayloadSchema: Schema<PersonalProfileListPayload> = z.object({
  num_available: z.number(),
  slot1: z.number(),
  slot2: z.number(),
  slot3: z.number(),
  slot4: z.number(),
  slot5: z.number(),
  slot6: z.number(),
});

export const PERSONAL_PROFILE_LIST_RESPONSE = {
  value: 174,
  name: "Personal Profile List Message",
  version: 36102,
  format: "b6b",
  fields: ["num_available", "slot1", "slot2", "slot3", "slot4", "slot5", "slot6"] as const,
  postprocess: rec => {
    const slots = [];
    for (let i = 1; i <= rec.num_available; i++) {
      const slot = rec[`slot${i}` as `slot${1 | 2 | 3 | 4 | 5 | 6}`];
      slots.push(slot);
    }
    return { numAvailable: rec.num_available, slots };
  },
  schema: personalProfileListPayloadSchema,
} as const satisfies TandemResponse<PersonalProfileListPayload, PersonalProfileList>;

export const PERSONAL_PROFILE_LIST_COMMAND = {
  value: 173,
  name: "Personal Profile List Request",
  version: 36102,
  response: PERSONAL_PROFILE_LIST_RESPONSE,
} as const satisfies TandemCommand<PersonalProfileListPayload, PersonalProfileList>;
